<template>
<section>
        <div class="container-fluid">
            <div class="row">
	        	<div class="col-12">
		        	<div class="h3 pb-2 black uppercase  mb-4">{{ name }} 
		        		<small class="italic" style="font-size:14px;">( <i class="fa fa-clock-o" aria-hidden="true"></i> {{ hours.formatted }})</small>
		        	</div>
	        	</div><!--col-->
            </div><!--row-->
            <div class="row">
	        	<div class="col-12">
	        	</div><!--col-->
            </div><!--row-->
            <div class="row">
	        	<div class="col-12 col-xl-6">

		        	<div class="bold pb-2 black text-uppercase  mb-2">Active programs</div>
		        	<div class="p-3 lightgray-content">
			        	<ul class="table-list  list-unstyled">
				        	<li class="mb-2 pb-2 border-bottom" v-for="course in courses">
				                
			                	<div class="d-flex align-items-center">
			                	
					                <div class="picture-container thumb-container" :style="{ 'background-image' : 'url('+course.image+')' }"></div>
				                	<div class="caption">
					                	<div class="title">{{ course.name }}</div>
					                	<div class="subtitle">{{ course.description }}</div>
				                	</div><!--caption-->
			                	</div>
				            </li>
			        	</ul>
		        	</div>
	        	</div><!--col-->
	            
	        </div><!--row-->
        </div>
    </section>
</template>

<script>

export default {

    data() {
        return {
	        courses : [],
	        name : '',
	        hours : {
	        	formatted : ''
	        },
			temp_current_org: this.$store.getters.getCurrentOrganization
           }
    },
	created : function(){
		this.hook_created();
	},
	computed:{
		get_current_org: function(){
			return this.$store.getters.getCurrentOrganization
		},
	},
	watch:{
		get_current_org: function(val){
			if(val == this.temp_current_org){
				return
			}else{
				this.temp_current_org = val
				this.hook_created();
			}
		},
	},
	mounted : function(){},
    methods: {
		hook_created : function(){
			this.getCourses();
			this.name = this.$store.getters.getName ? this.$store.getters.getName : this.$store.getters.getUser.organization;
			this.getHours();
		},
	    displayNotification: function(){
			this.$snotify.success('Holi', {
				timeout: 2000,
				showProgressBar: true,
				closeOnClick: false,
				pauseOnHover: true
			});
	    },
		getCourses : function(){
			var params = {
				filters : {
					page : this.current_page
				}
			}
			
			this.$store.dispatch('getCourses', params).then((res) => {
				this.courses = res.data.data;

			}).catch((error) => {
				console.log(error);
			});
		},

		getHours : function(){
			var params = {

			}

			this.$store.dispatch('getOrganizationHours', params).then((res) => {
				console.log(res);
				this.hours.formatted = res.data.data.formatted;
			}).catch((error) => {
				console.log(error);
			});
		}
    }
};


</script>



// WEBPACK FOOTER //
// src/components/organizations/OrganizationDashboardComponent.vue